import axios from 'axios'

export const getHtmlContent = (url) =>
  axios.get(url, {
    headers: {
      'Content-Type': 'text/html',
    },
  })
